<template>
    <div class="app-print-hide">
        <nav
            role="tablist"
            v-if="publicMenu.IsPublicMenuPublished"
            class="app-tabs-container dm-flex-row dm-justify-content-center app-print-hide"
            aria-label="Page navigation"
            @keydown="(e) => traverseNavList(e, 'app-navigation-button')"
        >
            <div class="app-tabs-container-inner app-phone-flex-column app-phone-full-width">
                <menu-button v-for="button in buttons" 
                    :key="button.label" 
                    :label="button.label" 
                    :is-primary="button.route === $route.name"
                    :icon-class="button.iconClass"
                    :route="button.route" :is-active="button.route === $route.name" 
                    @click="btnOnClick(button)">
                </menu-button>
            </div>
        </nav>
        <div v-if="showHero" class="app-header-container" :style="heroBackgroundStyle">
            <div class="app-header-container-inner app-phone-full-width">
                <h1 v-html="publicMenu.HeaderTitle" class="dm-text-center dm-padding-md dm-margin-0 dm-padding-bottom-sm app-print-hide app-header-inner-title"></h1>
                <div v-html="publicMenu.HeaderText" class="dm-padding-md dm-flex-column dm-justify-content-center dm-align-items-center dm-margin-bottom-md app-print-hide dm-text-center app-header-inner-text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import adaMixin from '../js/mixins/adaMixin';
import MenuButton from './menuButton.vue';

export default {
    name: 'menu-header',
    mixins: [adaMixin],
    components: {
        'menu-button': MenuButton
    },
    props: {
        showHero: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        publicMenu() {
            return this.$store.state.PublicMenuModule.publicMenu;
        },
        announcements() {
            return this.$store.state.PublicMenuModule.announcements;
        },
        buttons() {
            return [
                {
                    label: 'Menu',
                    route: 'calendar',
                    iconClass: 'app-icon-menu',
                    focus: 'menuCalendarPageNav'
                },
                {
                    label: 'Nutrition & Allergens',
                    route: 'nutrition-allergen',
                    iconClass: 'app-icon-nutrition',
                    focus: 'menuNutritionPageNav'
                },
                {
                    label: this.announcements.Title ? this.announcements.Title : 'Announcements',
                    route: 'announcements',
                    iconClass: 'app-icon-announcements',
                    condition: () => this.announcements.Display
                }
            ].filter(button => button.condition ? button.condition() : true);
        },
        heroBackgroundStyle() {
            return "background:url('" + this.$store.state.PublicMenuModule.publicMenu.HeroBackgroundUrl + "')";
        }
    },
    methods: {
        btnOnClick(button) {
            const slug = this.$route.params.districtSlug;
            this.$router.push(`/${slug}/${button.route}`);
            if(button.focus) {
                setTimeout(() => {
                    let focusElement = document.getElementById(button.focus)
                    if(focusElement) {
                        focusElement.focus()
                    }
                }, 500)
            }
        },
    }
}
</script> 

<style scoped>
    .app-header-container {
        width: 100%;
        border-radius: 14px;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;   
        background-size: cover !important;
        padding: 30px;
    }

    .app-header-container-inner {
        width: 50%;
        background-color: #F6F6F7;
        border-radius: 14px;
        opacity: 0.8;
    }

    .app-tabs-container-inner {
        display: flex;
        flex-wrap: wrap;
        background-color: #F6F6F7;
        border-radius: 14px;
        font-size: 32px;
        width: 55%;
        gap: 5px;
    }

    .app-tabs-container-inner button {
        flex: 1;
    }

    .app-header-inner-title {
        font-size: 32px;
    }

    .app-header-inner-text {
        font-size: 16px;
        padding: 0 20px;
    }

    .app-tabs-container {
        padding-bottom: 30px !important;
    }

    .app-tabs-container-inner button:first-child, .app-tabs-container-inner button:last-child, .app-tabs-container-inner-button-active {
        border-radius: 14px;
    }

    .app-tabs-container-inner button {
        cursor: pointer;
        
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 16px 10px 16px;
    }
    
    .app-tabs-container-inner button.app-button-primary {
        color: white !important;
    }
</style>